import React, { Component } from 'react';
import _ from 'lodash';

import AutoParkinglocationTable from '../components/AutoParkinglocationTable';
import AutoParkinglocationForm from '../components/AutoParkinglocationForm';

import AutoParkinglocationModel from '../components/AutoParkinglocationModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class AutoParkinglocationsScreen extends Component {

  state = {    
    dataLoading: true,
    dataAll: [],
    data: [],              
    parkinglocationFormModalVisible: false,    
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    AutoParkinglocationModel.getAll()
      .then(data => {        
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });   
      })
      .catch(err => {
        message.warning('Lokality se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,          
        });
      });
  }

  onSearch(searchText) {        
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['ParkingLocationName'].startsWith(searchText); })
    })
  }

  render() {
    return (      
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Park-Detect - Seznam lokalit</h2>
          <div style={{marginBottom: '20px'}}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Název lokality"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} offset={8} style={{textAlign: 'right'}}>
                <Button type="default" onClick={() => { this.loadData() }} style={{marginRight: 10}}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'PARKDETECT_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { window.open('/editor-parkdetect-locations.html', '_blank'); }} style={{ marginRight: 10 }}>Otevřít editor</Button>
                  : null} 
                {UserModel.isInRoles(['ADMIN', 'PARKDETECT_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({parkinglocationFormModalVisible: true}) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>          
          </div>
          <AutoParkinglocationForm 
            type="modal" 
            modalVisible={this.state.parkinglocationFormModalVisible} 
            onModalCancel={()=>{this.setState({ parkinglocationFormModalVisible: false })}}
            onSuccess={(form, values) => {           
              AutoParkinglocationModel.create(values)
                .then(() => {
                  form.resetFields(); 
                  this.loadData();
                })
                .catch(() => {
                  message.error('Nastala neočekávaná chyba při ukládání lokality!');
                });                            
            }} />
          <AutoParkinglocationTable
            data={this.state.data} 
            loading={this.state.dataLoading}
            onRemoveRow={(id)=>{
              this.setState({
                dataLoading: true          
              });
              AutoParkinglocationModel.remove(id)
                .then(() => {
                  this.loadData();
                })
                .catch(() => {
                  message.error('Nastala neočekávaná chyba při mazání lokality!');
                })
                .finally(() => {
                  this.setState({
                    dataLoading: false
                  });
                });                                          
            }}/>            
        </div>
      </Layout.Content>
    );
  }
}

export default AutoParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/AutoParkinglocationsScreen.js